module.exports = "/assets/Inter-SemiBold.2244d96c.woff2";